module.exports = __webpack_public_path__ + "static/media/1-.b0f67674.webp";